export default "__VITE_ASSET__BFTfjJHs__"